import {config as numberColumnConfig} from '../../common/NumberColumn';

export const prop = 'cRTotal';

export const config = (labels) =>
	numberColumnConfig({id: 'requests', label: labels.requests, width: 'minmax(var(--px-135), 1fr)', prop});
